import React, { useContext, useState, useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {IProps, IState} from './types';
import * as S from './styles';
import { useHistory } from 'react-router';
import {boxesIntersect, SelectionBox} from "react-drag-to-select";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PreviewComponent from '../PreviewComponent';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '@components/Loading';
import EmptyDesignIcon from '@assets/icons/emptyDesignIcon';
import Button from '@components/Button';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import selectors from '@state/selectors';
import MouseSelection from '@components/MouseSelection';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { IBrandConfigFont } from '@state/dsconfig/types';
import { checkLoadedFont, loadOEMFont } from '@utils/fonts';
import DeleteItem from '../BrandDetail/DeleteItem';
import DeleteBrand from '../DeleteBrand';

const BrandList:React.FC<IProps> = (props, state: IState) => {
  const{ searchSelectedAll, searchSelectedOne, searchValue, allFilters, sortByText, deleteBrandRequest} = useContext(BrandsContext);
  const history: any = useHistory();
  const counter = useSelector(selectors.brands.getCounterBrands);

  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const [allowClean, setAllowClean] = useState<boolean>(true);
  const [deleteBrand, setDeleteBrand] = useState<any>(undefined);
  const [loadedBrandIds, setLoadedBrandIds] = useState<string[]>([]);


  let selectedRefs = React.useRef([] as any);
  const stateRef = useRef<boolean>();
  useEffect(() => {
    if (stateRef) stateRef.current = allowClean;
  }, [allowClean]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [])

  const handleClickOutside = (e: any)=> {
    if(selectedRefs && selectedRefs.current){
        const ref: any = selectedRefs.current
        let found = false;
        if (ref) {
          ref.forEach(function (refDesign: any) {
            if (refDesign?.contains(e.target)) found= true;
          });

          setTimeout(() => {
            if (!found && stateRef.current) {
              if (props.onActions && !e.shiftKey){
                props.onActions([], 'SELECTEDDESIGNS');
                setSelectedIndexes([]);
              }
              
            }
          }, 200)
        }
    }
  }
  
  useEffect(() => {
    if (props.currentBrands) setSelectedIndexes([]);
  }, [props.currentBrands])

  const handleSelectionStart = useCallback(
    () => {
      setAllowClean(false);
    },
    []
  );

  useEffect(() => {
    if (props.currentBrands?.length) {
      props.currentBrands.filter(currentBrand => {
        return loadedBrandIds.find(loadedBrandId => loadedBrandId === currentBrand.id) ? false : true;
      }).map(currentBrand => {
        if (currentBrand.fonts?.length) {
          currentBrand.fonts.filter((font: any) => font.status === 'ACTIVE').map(async (font: IBrandConfigFont) => {
            try {
              if (!checkLoadedFont(font)) loadOEMFont(currentBrand.id, font);
            } catch(e) {
              console.error(e);
            }
          })
        }
      })
      setLoadedBrandIds(props.currentBrands.map(currentBrand => {return currentBrand.id ?? ``}));
    }
  }, [props.currentBrands]);

  const handleSelectionEnd = useCallback(
    (box: SelectionBox) => {
      let indexesToSelect = [] as any;
      let brandsToSelect = [] as any;
      const elementsContainer = document.getElementById("design-list");
      if (elementsContainer) {
        Array.from(elementsContainer.childNodes).forEach((item, index) => {
          const boundingBox = (item as Element).getBoundingClientRect();
          if (boxesIntersect(box, boundingBox)) {
            indexesToSelect.push(index);
            if (props.currentBrands) brandsToSelect.push(props.currentBrands[index]);
          }
        });
      }
      
      setSelectedIndexes(indexesToSelect);
      if (props.onActions) props.onActions(brandsToSelect, 'SELECTEDDESIGNS');
    },
    [props.currentBrands]
  );

  const handleSelectionChange = useCallback((box) => {
  }, []);

  const renderEndMessage = () => {
    return(
      <S.EndContainer>
      </S.EndContainer>
    )
  }

  const renderLoaderContainer = () => {
    if (searchSelectedOne) return '';
    else { 
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
    }
  }

  const handleCreateNewDesign = () => {
    history.push({pathname: '/studio'});
  }

  const updateSelectedDesigns = (design: any, add: boolean) => {
    let index =props.currentBrands.findIndex( (item:any) => item.id === design.id);
    if (index!==-1) {
      if (!add) setSelectedIndexes(selectedIndexes.filter(item => item!==index));
      else setSelectedIndexes([...selectedIndexes, index]);
    }
  }

  const onActions = (item: any, action: string, folder?:number) => {
    if (action==="ADDDESIGN") updateSelectedDesigns(item, true);
    if (action==="DELETEDESIGN") updateSelectedDesigns(item, false);
    if (action==="DELETEBRAND"){       
      setDeleteBrand(item)
    };

    if (action==="CANCELDELETEBRAND")
    { 
      deleteBrandRequest()
      setDeleteBrand(undefined)
    };

    
    

    if (folder && props.onActions) props.onActions(item,action, folder);
    else if (props.onActions) props.onActions(item, action);
  }
  
  return ( 
    <S.Root
      id="infinite-scroll-all-designs"
    >
      {
        props.isLoading ?
        <S.AllLoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.AllLoaderContainer>
        : props.hasNoBrands ?
          <S.HasNoBrandsContainer>
            <S.EmptyIcon>
              <S.EmptyIconScale>
                <EmptyDesignIcon/>
              </S.EmptyIconScale>
            </S.EmptyIcon>
            <S.EmptyTextContainer>
              <S.EmptyTitle>
                No Brands added yet
              </S.EmptyTitle>
              <S.EmptySubtitle>
                Add a brand or OEM to set logos, colors, and fonts to ensure your designs are compliant with the OEM standards, as well as your dealership's branding guidelines.
              </S.EmptySubtitle>
              <S.EmptyButton>
                <Button
                  icon="add" 
                  label="ADD BRAND"
                  style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 153, height: 36, boxSizing: 'border-box'}}
                  labelStyle={{color: "white", fontWeight: '500'}}
                  onClick={handleCreateNewDesign}
                />
              </S.EmptyButton>
            </S.EmptyTextContainer>
          </S.HasNoBrandsContainer>
        :
          <S.DesignsContainer onMouseDown={()=>setAllowClean(true)}>
            <MouseSelection onSelectionChange={handleSelectionChange} onSelectionEnd={handleSelectionEnd} onSelectionStart={handleSelectionStart}/>
          
            <InfiniteScroll
              dataLength={props.currentBrands ? props.currentBrands.length : 0}
              next={() => props.loadMoreBrands(undefined)}              
              hasMore={props.hasMore}
              loader={renderLoaderContainer()}
              scrollableTarget="infinite-scroll-all-designs"
              endMessage={renderEndMessage()}
              style={{
                width: '100%',
                minHeight: '200px',
                overflowX: 'hidden',
              }}
            >
              <S.DesignsWrap flex={props.currentBrands && props.currentBrands.length > 0}>
                <TransitionGroup className="group-list" id="design-list">
                  {
                    props.currentBrands && props.currentBrands.length > 0 &&
                    props.currentBrands.map((brand: any, index: number) => {
                      return (
                        <CSSTransition key={brand.id} timeout={600} classNames="item">
                          <div ref={selectedIndexes.includes(index) ? ref=>selectedRefs.current.push(ref) : null}>
                          <PreviewComponent
                            index={index}
                            key={index}
                            item={brand}
                            showMetadata={true}
                            onActions={onActions}
                            selected={selectedIndexes.includes(index) }
                            dealerUser={props.dealerUser}
                          />
                          </div>
                        </CSSTransition>
                      )
                    })
                  }
                </TransitionGroup>               
                {
                  props.hasMore === false && props.currentBrands?.length === 0 &&
                  <S.TabNoDesignsContainer>
                    <S.EmptyIcon>
                      <S.EmptyIconScale>
                        <EmptyDesignIcon/>
                      </S.EmptyIconScale>
                    </S.EmptyIcon>
                    <S.EmptyTextContainer>
                      <S.EmptyTitle>
                        No brands added yet
                      </S.EmptyTitle>
                      <S.TabEmptySubtitle>
                      Add a brand or OEM to set logos, colors, and fonts to ensure your designs are compliant with the OEM standards, as well as your dealership's branding guidelines.
                      </S.TabEmptySubtitle>
                    </S.EmptyTextContainer>
                  </S.TabNoDesignsContainer>
                }
              </S.DesignsWrap>
            </InfiniteScroll>
          </S.DesignsContainer>
      }

      {        
        deleteBrand &&
        <DeleteBrand 
          elementName={"brand"}
          open={true}
          isSaving={false}
          onActions={onActions}
          item={deleteBrand}
        />
      }
    </S.Root>
  );
}

export default BrandList;